import React, { Component } from "react";
import FilterGroupContentV2 from "./FilterGroupContentV2";
import FilterGroupContentV2Mobile from "./FilterGroupContentV2Mobile";

class FilterControlPanelV2 extends Component {
    constructor(props) {
        super(props);  
        this.state = {
            offsetWidth : 0,
        }
    }
    // updateDimensions = () => {
    //     var width = document.getElementById('acorn-body');
    //     this.setState({ deviceWidth: width.offsetWidth });   
    // };
    // componentDidMount() {
    //     var that = this;
    //     window.addEventListener("resize", (ev) => {
    //         var width = document.getElementById('acorn-body');
    //         that.setState({ deviceWidth : width.offsetWidth});
    //     });
    // }
    // componentWillUnmount() {
    //     window.removeEventListener('resize', this.updateDimensions);
    // }
    // handleshowFilters(){
    //         // this.setState({ showFilters: true });
    //       this.setState({ displayFilter: true})
    //         // this.handleChangeAllOffersUpdate();
      
       
    // }
    // showFilter = (status) => {
    //     this.setState({ displayFilter: status, filterToggleClass: status ? '' : 'accordion-toggle' });
    //     if(status) { this.setState({ mobileFilterHeader: 'Hide Filters'}); }
    //     else { this.setState({ mobileFilterHeader: 'Expand Filters'}); }
    //     this.GetMaxDivHeight();
    // }
    render() {

        return (
            <div>
            { this.props.deviceWidth >= 768 ?
                <FilterGroupContentV2
                    creditScore={this.props.creditScore}
                    lenderState={this.props.lenderState}
                    loanPurpose={this.props.loanPurpose}
                    loanAmount={this.props.loanAmount}
                    annualIncome={this.props.annualIncome}
                    loanTerm={this.props.loanTerm}
                    zipCode={this.props.zipCode}
                    onLoanPurposeChange={this.props.onLoanPurposeChange}
                    onLenderStateChange={this.props.onLenderStateChange}
                    onCreditScoreChange={this.props.onCreditScoreChange}
                    onLoanAmountChange={this.props.onLoanAmountChange}
                    onIncomeChange={this.props.onIncomeChange}
                    onLoanTermChange={this.props.onLoanTermChange}
                    onUpdateResultClick={this.props.onUpdateResultClick}
                    onZipCodeChange={this.props.onZipCodeChange} 
                    isGeoBasedZipCode={this.props.isGeoBasedZipCode}
                    onSortByChage={this.props.onSortByChage} 
                    sortByValue={this.props.sortByValue}
                    // currentDevice={this.props.currentDevice}
                    creditScoreIndex={this.props.creditScoreIndex}
                    versionLP={this.props.versionLP}
                    rootId={this.props.rootId}
                    deviceWidth={this.props.deviceWidth}
                    />
                    :
                      this.props.showFilters &&
                   
                <FilterGroupContentV2Mobile
                    creditScore={this.props.creditScore}
                    lenderState={this.props.lenderState}
                    loanPurpose={this.props.loanPurpose}
                    loanAmount={this.props.loanAmount}
                    annualIncome={this.props.annualIncome}
                    loanTerm={this.props.loanTerm}
                    zipCode={this.props.zipCode}
                    onLoanPurposeChange={this.props.onLoanPurposeChange}
                    onLenderStateChange={this.props.onLenderStateChange}
                    onCreditScoreChange={this.props.onCreditScoreChange}
                    onLoanAmountChange={this.props.onLoanAmountChange}
                    onIncomeChange={this.props.onIncomeChange}
                    onLoanTermChange={this.props.onLoanTermChange}
                    onUpdateResultClick={this.props.onUpdateResultClick}
                    onZipCodeChange={this.props.onZipCodeChange} 
                    isGeoBasedZipCode={this.props.isGeoBasedZipCode}
                    onSortByChage={this.props.onSortByChage} 
                    sortByValue={this.props.sortByValue}
                    // currentDevice={this.props.currentDevice}
                    creditScoreIndex={this.props.creditScoreIndex}
                    versionLP={this.props.versionLP}
                    rootId={this.props.rootId}
                    closeFilters={this.props.closeFilters}

                    // handleshowFilters={this.handleshowFilters}
                    deviceWidth={this.props.deviceWidth}
                /> 
    }
            </div> 
        ); 
    } 
}

export default FilterControlPanelV2;


// WEBPACK FOOTER //
// ./src/FilterControlPanelV2.js